<button
  id="expandAll"
  type="button"
  class="btn btn-sm btn-outline mb-0 me-1"
  [disabled]="allExpanded"
  (click)="onExpandAll()"
>
  <i-lucide name="maximize-2"></i-lucide>
  Expand All
</button>
<button
  id="collapseAll"
  type="button"
  class="btn btn-sm btn-outline mb-0"
  [disabled]="allCollapsed"
  (click)="onCollapseAll()"
>
  <i-lucide name="minimize-2"></i-lucide>
  Collapse All
</button>
